import * as ChapterType from "utils/ChapterType";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import { createSelector } from "reselect";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import getSlideshowSlides from "selectors/chapter/slideshow/getSlideshowSlides";

// import type {VerseStore} from "utils/interfaces/VerseStore";

export default createSelector(
  getChapterEntity,
  getPlaybackState,
  getSlideshowSlides,
  (chapterEntity, playbackState, slideshowSlides) => {
    if (!playbackState) return 0;

    if (
      !chapterEntity ||
      chapterEntity.type !== ChapterType.SLIDESHOW ||
      !slideshowSlides.length
    ) {
      return 0;
    }

    const slideshowSlidesWithDurations = slideshowSlides.reduce(
      (memo, slide) => {
        if (!memo.length) {
          return [
            {
              end: slide.duration - 1,
              slide,
              start: 0,
            },
          ];
        }

        const lastEnd = memo[memo.length - 1].end;

        return [
          ...memo,
          {
            end: lastEnd + slide.duration,
            slide,
            start: lastEnd + 1,
          },
        ];
      },
      [],
    );

    const constPlaybackState = playbackState;
    if (!constPlaybackState) {
      return 0;
    }

    if (
      constPlaybackState.time >=
      slideshowSlidesWithDurations[slideshowSlidesWithDurations.length - 1]
        .start
    ) {
      return slideshowSlidesWithDurations.length - 1;
    }

    let matchingSlide = slideshowSlidesWithDurations.find(
      (startEnd) =>
        startEnd.start <= constPlaybackState.time &&
        constPlaybackState.time <= startEnd.end,
    );

    if (!matchingSlide) {
      // find the closest start time to the current time
      matchingSlide = slideshowSlidesWithDurations.reduce(
        (lastStartEnd, startEnd) => {
          if (
            Math.abs(lastStartEnd.start - constPlaybackState.time) >
            Math.abs(startEnd.start - constPlaybackState.time)
          ) {
            return startEnd;
          }
          return lastStartEnd;
        },
      );
    }

    if (!matchingSlide) {
      // still no match then something went bad.  Start at 0
      return 0;
    }

    const activeSlideIndex = slideshowSlides.indexOf(matchingSlide.slide);
    return activeSlideIndex;
  },
);
